import React from 'react'
import { createRoot } from 'react-dom/client'
import { Container } from './widget/Container'
import { getCookieUserId } from './common/util'
import { Bridge } from './widget/widgetBridge'

import '../css/widget_preview.scss'

import containerCss from './widget/container.scss?inline'
import widgetCss from './widget/widget.scss?inline'

function init() {
  let { botWidgetConfig } = document.body.dataset
  const config = JSON.parse(botWidgetConfig)
  config.userId = config.userId || getCookieUserId()

  const container = document.createElement('div')
  if (config.className) {
    container.className = config.className
  }
  container.id = 'botsquad-container'
  document.body.appendChild(container)

  const style = document.createElement('style')
  style.setAttribute('v', 'botsquad')
  style.textContent = containerCss + widgetCss
  document.head.appendChild(style)
  const bridge = new Bridge('host')

  const root = createRoot(container)
  root.render(<Container config={config} bridge={bridge} />)

  window.addEventListener('message', ({ data }) => {
    const { event, payload } = data
    if (!event) return
    if (event === 'widget') {
      BotSqd.configure(payload)
    }
  })
}

if (/comp|inter|loaded/.test(document.readyState)) {
  init()
} else {
  document.addEventListener('DOMContentLoaded', init, false)
}
